import React from "react";
import PropTypes from "prop-types";
import "./FormGrid.css";
/**
 * @desc FormGridstyle
 * @param props
 * @return null
 */
const getGridStyle = (grid, gap) => ({
  gridTemplateColumns: grid,
  gridColumnGap: gap
});
/**
 * @desc FormGrid
 * @param props
 * @return null
 */
const FormGrid = props => {
  const { className, grid, gap } = props;
  const gridStyle = props.grid ? getGridStyle(grid, gap) : {};
  return (
    <div className={"ui-form-grid " + className} style={gridStyle}>
      {props.children}
    </div>
  );
};

FormGrid.propTypes = {
  /** ClassName will be injected into the component's container. You can use ClassName for adhoc styling. */
  className: PropTypes.string,
  /** The CSS grid definition for the FormGrid. */
  grid: PropTypes.string,
  /** The CSS grid gap . */
  gap: PropTypes.string
};

FormGrid.defaultProps = {
  className: "",
  grid: "auto",
  gap: "40px"
};

export default FormGrid;



// WEBPACK FOOTER //
// ./src/components/UI/FormGrid/FormGrid.js